define((require) => {
    "use strict";

    const {Logger}                                 = require("shared/util/Logger");
    const SalesforceCommerceQuickViewSiteGenesisStrategy = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisStrategy");
    const Action                                 = require("shared/ui/experience/action/Action");
    const {trim}                            = require("shared/util/StringUtils");

    const log = new Logger("SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy");

    /**
     * Exposes a SalesforceCommerce QuickView SiteGenesis No function Strategy Class,
     * which handles the scenario of when the quickview function does not exists
     * on client side.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy
     */
    return SalesforceCommerceQuickViewSiteGenesisStrategy.extend({

        /**
         * Handles scenario when the QuickView does ont exists on client site,
         * so we just log the warning.
         */
        open(id) {
            // Trim for consistency with actual strategy used to call SalesforceCommerceQuickviewService.open... which trims
            // the product id as well...
            const msg = `SalesforceCommerce Product Id: ${trim(id)}`;
            log.info(msg);

            if (Action.NOT_EMBEDDED_MESSAGE) { // only in editor
                alert(`${msg}\n\n${Action.NOT_EMBEDDED_MESSAGE}`);
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy.js